import {
  BusinessInfo,
  CreateBusinessProfileRequest,
  UpdateBusinessProfileRequest,
} from '@taxfyle/api-internal/internal/business_profile_pb'
import { ContactInformation } from '@taxfyle/api-internal/shared/types/contact_info_pb'
import { Id } from 'types/definitions'
import { mapContactInfoToProto } from '../individual-info/individualProfileGrpcDtoMapper'

export function mapBusinessInfoToProto(
  input: BusinessInfo.AsObject,
): BusinessInfo {
  return new BusinessInfo()
    .setBusinessName(input.businessName)
    .setDateOfIncorporation(input.dateOfIncorporation)
    .setEmployerIdentificationNumber(input.employerIdentificationNumber)
}

export interface CreateBusinessProfileInput {
  workspaceId: Id
  ownerUserId: Id
  businessInfo?: BusinessInfo.AsObject
  contactInfo?: ContactInformation.AsObject
}

export function mapCreateBusinessProfileRequestToProto(
  input: CreateBusinessProfileInput,
): CreateBusinessProfileRequest {
  const request = new CreateBusinessProfileRequest()
    .setWorkspaceId(Id.assert(input.workspaceId))
    .setOwnerUserId(Id.assert(input.ownerUserId))
  if (input.businessInfo) {
    request.setBusinessInfo(mapBusinessInfoToProto(input.businessInfo))
  }
  if (input.contactInfo) {
    request.setContactInfo(mapContactInfoToProto(input.contactInfo))
  }
  return request
}

export interface UpdateBusinessProfileInput {
  id: Id
  businessInfo?: BusinessInfo.AsObject
  contactInfo?: ContactInformation.AsObject
}

export function mapUpdateBusinessProfileRequestToProto(
  input: UpdateBusinessProfileInput,
): UpdateBusinessProfileRequest {
  const request = new UpdateBusinessProfileRequest().setId(Id.assert(input.id))
  if (input.businessInfo) {
    request.setBusinessInfo(mapBusinessInfoToProto(input.businessInfo))
  }
  if (input.contactInfo) {
    request.setContactInfo(mapContactInfoToProto(input.contactInfo))
  }
  return request
}
